module.exports = __webpack_public_path__ + "static/media/06.ffcd5ce4.png";